import { z } from 'zod';
import { ISector } from './Sector';

export interface InboxApi {
  idInbox: string;
  idTotemSector: string;
  phoneNumber: string;
  documentNumber: string;
  trackNumber: string;
  sector: ISector;
  hasAgenda: string;
  shippingLocation: string;
  status: string;
  createdAt: string;
  updatedAt: string;
  shippingId: string;
  dtStart?: string;
  reason?: string | null;
  tags?: string;
  attentionUserName?: string | null;
  isTaken?: boolean;
  takenById?: string;
  takenByName?: string;
}

export interface SectorStats {
  delivered: number;
  notDelivered: number;
  total: number;
  avg: string;
}

export interface InboxStats {
  [sectorName: string]: SectorStats;
}

export interface InboxApiResponse {
  count: number;
  items: InboxApi[];
  stats?: InboxStats;
}

export type InboxStatus =
  | 'SCHEDULED_PENDING'
  | 'PENDING'
  | 'ATTENDING'
  | 'FINALIZED_NOT_DELIVERED'
  | 'FINALIZED_DELIVERED'
  | 'UNKNOWN';
``;

export type InboxFilter = Pick<
  InboxApi,
  'shippingId' | 'documentNumber' | 'phoneNumber' | 'sector'
> & {
  statuses: InboxStatus[];
};

export interface ServeCustomer {
  inboxId: string;
  attentionUser: string;
}

export enum Tags {
  LOST = 'LOST',
  PREPARED = 'PREPARED',
  FOUND = 'FOUND',
  UNKNOWN = 'UNKNOWN',
}

export interface FinalizeService {
  inboxId: string;
  documentNumber: string;
  success: boolean;
}

export const finalizationInboxSchema = z.object({
  documentNumber: z
    .string()
    .min(8, 'El documento debe contenter al menos 8 caracteres')
    .max(8, 'El documento debe contenter no más de 8 caracteres'),
});

export type FinalizationInboxSchema = z.infer<typeof finalizationInboxSchema>;

export const defaultValues: FinalizationInboxSchema = {
  documentNumber: '',
};
